import React from 'react'
import process2Img from "../../assets/Images/home/process-2.png";

const Process = () => {
  return (
    <section className="w-full bg-[#F2F6EF] py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        
      <div className="shine">  <img src={process2Img} alt="" /></div>
        </div>
        </section>
  )
}

export default Process